import assistant from './assistant.json';
import auth from './auth.json';
import common from './common.json';
import couple from './couple.json';
import dashboard from './dashboard.json';
import dialogs from './dialogs.json';
import events from './events.json';
import gallery from './gallery.json';
import guests from './guests.json';
import invitationEditor from './invitation_editor.json';
import messages from './messages.json';
import nav from './nav.json';
import notifications from './notifications.json';
import organizer from './organizer.json';
import promo from './promo.json';
import quiz from './quiz.json';
import rsvp from './rsvp.json';
import seating from './seating.json';
import settings from './settings.json';
import upload from './upload.json';
import validation from './validation.json';
import sandbox from './sandbox.json';

export default {
  ...common,
  ...nav,
  ...auth,
  ...dashboard,
  ...dialogs,
  ...events,
  ...couple,
  ...guests,
  ...seating,
  ...rsvp,
  ...gallery,
  ...upload,
  ...settings,
  ...notifications,
  ...organizer,
  ...quiz,
  ...validation,
  ...messages,
  ...sandbox,
  ...promo,
  ...assistant,
  ...invitationEditor,
};
